import React, {Component} from 'react';
import BottomLinks from "./common/BottomLinks";
import * as Constants from "./common/Constants";
import queryString from "query-string";

class UpgradesError extends Component {
    state = {
        msisdn : '',
        date : ''
    }
    componentDidMount() {
        document.title = 'Upgrade';
        let params = queryString.parse(this.props.location.search);
        if (params !== undefined) {
            let msisdn = '';
            let date = '';
            if(!Constants.isUndefined(params.msisdn)){
                msisdn = params.msisdn;
            }
            if(!Constants.isUndefined(params.date)){
                date = params.date;
            }
            this.setState({
                msisdn : msisdn,
                date : date
            })
        }
    }
    render() {
        return (
            <React.Fragment>
                <div className="main-content-wrapper">
                    <div>
                        <div className="page-breadCrumb">
                            <a className="url_link" onClick={() => Constants.redirectToHome()}>Home</a>
                            <svg focusable="false" aria-hidden="true" className="icon">
                                <use xlink="http://www.w3.org/1999/xlink" href="#icon-chevron-right" />
                            </svg>
                            <a className="url_link active">Upgrade</a>
                        </div>
                    </div>
                    <div className="parent-main-wrapper leads-form">
                        <div className="popUP-section">
                            <div className="error">
                                <span className="svgOuter">
                                    <svg focusable="false" aria-hidden="true" className="icon top-svg">
                                        <use xlink="http://www.w3.org/1999/xlink" href="#icon-close" />
                                    </svg>
                                </span>
                                <label className="title">Sorry, this number can't be upgraded yet</label>
                                <span className="message-seprator" />
                                <span
                                    className="sub-title">You’ll only be able to upgrade your contract for <strong>{this.state.msisdn}</strong> from:</span>
                                <span className="date-txt">{this.state.date}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <BottomLinks/>
            </React.Fragment>
        );
    }

}

export default UpgradesError;
